export enum MenssageType{
  Success = 1,
  Warning = 2,
  Error = 3,
  Alert
}
